import React from 'react';

interface LogoProps {
  variant?: 'light' | 'dark';
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ 
  variant = 'light', 
  size = 'medium',
  className = '' 
}) => {
  const baseClasses = variant === 'light' ? 'logo-text' : 'logo-text-dark';
  const sizeClasses = {
    small: 'logo-text-small',
    medium: '',
    large: 'logo-text-large'
  };

  return (
    <div className={`flex items-center ${className}`}>
      <span className={`${baseClasses} ${sizeClasses[size]}`}>
        Crawly<span className="font-normal">Carl</span>
      </span>
    </div>
  );
};

export default Logo;
